"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _reactQuill = require("react-quill");
var Link = _reactQuill.Quill.import('formats/link');
var LinkFormatAttributesList = ['href', 'target'];

/**
 * A custom block-level Blot for inserting links supported by the RichTextEditor.
 * Designed to extend and support Quill's built-in Link blot.
 *
 * To add to the editor, register this Blot with Quill using the register API.
 *
 * @extends Link
 */
var CustomLink = /*#__PURE__*/function (_Link) {
  (0, _inheritsLoose2.default)(CustomLink, _Link);
  function CustomLink() {
    return _Link.apply(this, arguments) || this;
  }
  /**
   * Creates a link DOM node with href and target attributes
   *
   * @param {string/object} value - an object containing the url and the target of the link
   * @returns node - the corresponding DOM node for the link
   */
  CustomLink.create = function create(value) {
    var _value$href;
    /**
     * super.create(url) assigns the following attributes to the anchor element:
     *  href: this.sanitize(url)
     *  rel: noopener noreferrer - prevents performance issues and security vulnerabilities when using the _blank target
     *  target: _blank
    */
    var node = _Link.create.call(this, (_value$href = value.href) != null ? _value$href : value);

    // set the target attribute if provided and not null/empty string
    if (value.target) {
      node.setAttribute('target', value.target);
    } else {
      node.removeAttribute('target');
    }
    node.addEventListener('click', function (event) {
      var _node$firstChild;
      event.preventDefault();

      // some pasted images can be wrapped in links
      // in this case on click we don't want to navigate to the link
      // but we want to be able to resize the image
      if (((_node$firstChild = node.firstChild) == null ? void 0 : _node$firstChild.tagName) !== 'IMG') {
        node.setAttribute('rel', 'external');
        window.open(node.getAttribute('href'), value.target);
      }
    });
    return node;
  }

  /**
   * Returns the format values represented by domNode if it is this Blot's type,
   * no check that domNode is this Blot's type is required
   *
   * @param {Node} domNode - The domNode representing the blot
   * @returns the format values represented by the domNode
   */;
  CustomLink.formats = function formats(domNode) {
    return LinkFormatAttributesList.reduce(function (formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }

  /**
   * Apply format to blot. Should not pass onto child or another blot
   * If value is null, the name attribute is removed from the blot
   *
   * @param {String} name - Name of the format
   * @param {Any} value - Value of the format
   */;
  var _proto = CustomLink.prototype;
  _proto.format = function format(name, value) {
    if (LinkFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      _Link.prototype.format.call(this, name, value);
    }
  };
  return CustomLink;
}(Link);
CustomLink.tagName = 'A';
CustomLink.blotName = 'link';
var _default = CustomLink;
exports.default = _default;